(() => {
  function init(root = document) {
    root.querySelectorAll('[data-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.dataset.toggle);
        if (!panel) return;
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        if (open) panel.querySelector('input')?.focus();
      });
    });
    root.querySelectorAll('[data-reviews]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const items = [...el.querySelectorAll('[data-review]')];
      let current = 0;
      const show = () => {
        items.forEach((item, i) => { item.hidden = i !== current; });
        const counter = el.querySelector('[data-review-counter]');
        if (counter) counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      };
      el.querySelectorAll('[data-review-step]').forEach(b => b.addEventListener('click', () => {
        if (!items.length) return;
        current = (current + Number(b.dataset.reviewStep) + items.length) % items.length;
        show();
      }));
      show();
    });
    root.querySelectorAll('[data-product]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const data = JSON.parse(el.querySelector('[data-variants]')?.textContent || '[]');
      const select = el.querySelector('[name="id"]');
      const button = el.querySelector('[data-add-button]');
      const price = el.querySelector('[data-product-price]');
      const update = () => {
        const variant = data.find(v => String(v.id) === select?.value);
        if (!variant || !button) return;
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to bag' : 'Sold out';
        if (price && window.NxtMoney) price.textContent = window.NxtMoney(variant.price);
      };
      select?.addEventListener('change', update);
      const main = el.querySelector('[data-main-image]');
      el.querySelectorAll('[data-thumb]').forEach(b => b.addEventListener('click', () => {
        if (main) { main.src = b.dataset.src; main.alt = b.dataset.alt || ''; }
        el.querySelectorAll('[data-thumb]').forEach(other => other.setAttribute('aria-pressed', String(other === b)));
      }));
      const dialog = el.querySelector('dialog');
      el.querySelector('[data-zoom]')?.addEventListener('click', () => {
        const image = dialog?.querySelector('img');
        if (dialog && image && main) { image.src = main.src; image.alt = main.alt; dialog.showModal(); }
      });
      el.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    });
  }
  window.NxtMoney = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.NxtCurrency || 'USD' }).format(cents / 100); }
    catch { return '$' + (cents / 100).toFixed(2); }
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-toggle][aria-expanded="true"]').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(b.dataset.toggle); if (panel) panel.hidden = true;
    });
  });
})();
